import React from 'react';
import styled from 'styled-components';

import './ReactionToggle.scss';

const Container = styled.div`
	display: flex;
	justify-content: center;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 40px;
	pointer-events: all;
	user-select: none;

	@media screen and (max-width: 992px) and (orientation: portrait) and (hover: none) and (pointer: coarse) {
		padding: 10% !important;
		height: 4vh !important;
		min-height: 40px !important;
		width: 4vh !important;
		min-width: 40px !important;
		margin-bottom: 0.5vh;
	}
`;

const Icon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" style={{ position: 'fixed' }}>
		<g id="Group_8026" data-name="Group 8026" transform="translate(0.21 0.11)">
			<rect id="Rectangle_63" data-name="Rectangle 63" width="34" height="34" rx="4" transform="translate(-0.21 -0.11)" />
			<path
				id="Icon_3"
				data-name="Icon 3"
				d="M13.292.57a3.9,3.9,0,0,0-1.235.21,4.974,4.974,0,0,0-1.172.567c-.36.238-.672.462-.931.668a9.569,9.569,0,0,0-.742.665,9.569,9.569,0,0,0-.742-.665c-.259-.21-.57-.43-.931-.668A4.974,4.974,0,0,0,6.367.78,3.9,3.9,0,0,0,5.132.57,4.685,4.685,0,0,0,1.707,1.781,4.485,4.485,0,0,0,.468,5.14,4.243,4.243,0,0,0,.7,6.487a5.951,5.951,0,0,0,.521,1.183,8.478,8.478,0,0,0,.665.952c.248.308.427.521.542.64s.2.2.269.255l6.092,5.878a.586.586,0,0,0,.43.175.6.6,0,0,0,.43-.175l6.081-5.857a6.38,6.38,0,0,0,2.236-4.395,4.485,4.485,0,0,0-1.239-3.359A4.715,4.715,0,0,0,13.292.57Z"
				transform="translate(7.572 8.82)"
				fill="#fff"
			/>
		</g>
	</svg>
);

export default function ReactionToggle({ heartAnimation, container }) {
	return (
		<Container onClick={heartAnimation} style={{ position: 'relative', userSelect: 'none' }} tabIndex={-1}>
			<Icon />
			{container}
		</Container>
	);
}
